import { Block, ListItem, ListItemLabel } from "@mezo-org/mezo-clay"

export default function DepositingAssetListItem({
  amount,
  icon,
}: {
  amount: string
  icon: string
}) {
  return (
    <ListItem
      overrides={{
        Root: {
          style: ({ $theme }) => ({
            borderRadius: $theme.borders.radius400,
            background: $theme.colors.backgroundSecondary,
          }),
        },
        Content: { style: { borderBottom: "none" } },
      }}
      artwork={() => <Block as="img" width="24px" height="24px" src={icon} />}
    >
      <ListItemLabel>{amount}</ListItemLabel>
    </ListItem>
  )
}
